






































































import Vue from 'vue';
import Component from 'vue-class-component';
import { PS } from '@/store/infosPSBEN/types';

const Props = Vue.extend({
	props: {
		infosPs: {
			type: Object as () => PS,
			required: true
		}
	}
});

@Component
export default class HeaderMenu extends Props {
	hoverProfilBtn = false;

	get isCDS(): boolean {
		return this.infosPs.numAM.substring(2, 3) === '0' && this.infosPs.typeIdentifiant !== '99';
	}

	get isDoctor(): boolean {
		return this.infosPs.categorie === '10';
	}
}
